<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h5 class="info-text">General Information</h5>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="address"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>directions</md-icon>
              <label>Mother Name</label>
              <md-input v-model="mother_name" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="address"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>directions</md-icon>
              <label>Father Name</label>
              <md-input v-model="father_name" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="birth_date"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="birth_date"
              md-immediately
            >
              <label>Birth Date</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-small-size-100">
          <ValidationProvider
            name="country_of_birth"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>add_location</md-icon>
              <label>Country of birth</label>
              <md-select v-model="country_of_birth" name="country_of_birth">
                <md-option value="">Select Country</md-option>
                <md-option
                  v-for="c in countries"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="nationality"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>public</md-icon>
              <label>Nationality</label>
              <md-select v-model="nationality" name="nationality">
                <md-option value="">Select Country</md-option>
                <md-option
                  v-for="c in countries"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="country_of_residence"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>add_location</md-icon>
              <label>Country of residence</label>
              <md-select
                v-model="country_of_residence"
                name="country_of_residence"
                @md-selected="onChangeCountry"
              >
                <md-option value="">Select Country</md-option>
                <md-option
                  v-for="c in countries"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="city_of_residence"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>add_location</md-icon>
              <label>City of residence</label>
              <md-input v-model="city_of_residence" name="city" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="whatsapp_number"
            rules="required|numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>perm_phone_msg</md-icon>
              <label>Whatsapp number</label>
              <md-input v-model="whatsapp_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider
            name="address"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>directions</md-icon>
              <label>Address (Max 300 character)</label>
              <md-input v-model="address" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-100">
          <h5 class="info-text">Passport Information</h5>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="passport_date_of_issue"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="passport_date_of_issue"
              md-immediately
            >
              <label>Passport date of issue</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="passport_number"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>layers</md-icon>
              <label>Passport Number</label>
              <md-input v-model="passport_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="passport_date_of_expire"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="passport_date_of_expire"
              md-immediately
            >
              <label>Passport date of expire</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-checkbox v-model="need_visa">Need visa?</md-checkbox>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      mother_name: null,
      father_name: null,
      birth_date: null,
      country_of_birth: null,
      nationality: null,
      passport_number: null,
      passport_date_of_expire: null,
      passport_date_of_issue: null,
      country_of_residence: null,
      city_of_residence: null,
      address: null,
      whatsapp_number: null,
      need_visa: false,
      countries: [],
      cities: []
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit("on-validated", res);
        return res;
      });
    },
    onChangeCountry() {
      let params = { country: this.country_of_residence };
      this.$store
        .getCities(params, true)
        .then(response => {
          this.cities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.$store
      .getCountries()
      .then(response => {
        this.countries = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style></style>
